// extracted by mini-css-extract-plugin
module.exports = {"contactUs":"FooterContact-module--contactUs--_GcKR","container":"FooterContact-module--container--3MwXl"};